module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/store_images/3_76f1bf7a7f6d45dd96ba9651cafe02c5.png";